export const actualPolicies = [
    {
        id: 1,
        initialValue: '',
        title: 'Payment',
        description: 'You will receive an invoice at the end of each month for lessons that have already occurred. There are 2 ways to pay through the invoice: ACH bank payment and debit/credit card. Please make your payment no later than the 7th of the month.'
    },
    {
        id: 2,
        initialValue: '',
        title: 'Cancellations',
        description: "To respect the teacher's time, we ask that cancellations are kept to an absolute minimum. In the case of a cancellation, you can schedule a makeup lesson provided your teacher has openings in their schedule. Please note: We have a 24 hour cancellation policy, so lessons cancelled with less than 24 hour notice will be invoiced. Please reach out to your teacher directly if you need to cancel a lesson."
    },
    {
        id: 3,
        initialValue: '',
        title: 'Safety',
        description: "All of our teachers must pass a background check, but for everyone’s peace of mind, lessons should take place out in an open area with a parent or guardian nearby. Our teachers will do their very best to arrive on time, but please understand that travel time can be affected by traffic or weather, and we prioritize their safety. In the case of bad weather, please be understanding if your teacher requests a makeup lesson or to opt for a video lesson that week."
    },
    {
        id: 4,
        initialValue: '',
        title: 'Materials',
        description: "Your teacher will either have materials to share, or ask you to pick up music. If your teacher purchases materials for you, the cost will be included in your next invoice."
    },
    {
        id: 5,
        initialValue: '',
        title: "Lesson Time",
        description: "Our teachers will do their very best to arrive on time, but please understand they are driving from house to house, which may sometimes be affected by traffic or weather."
    },
    {
        id: 6,
        initialValue: '',
        title: "Practice",
        description: "It is advised that all students make practice a daily habit. Your teacher will help the student come up with a practice plan, and parents are encouraged to be involved with the plan."
    },
    {
        id: 7,
        initialValue: '',
        title: "Discontinuing Lessons",
        description: "Because your teacher reserves a weekly in‑home time slot specifically for your family, we require 4 weeks written notice (email or text) if you wish to discontinue lessons. Tuition will continue to be charged for your regular weekly lesson time for 4 weeks from the date notice is given. You are welcome to use all remaining lessons during this period. Because this time is reserved for your family and cannot be reassigned mid‑notice, missed lessons during the notice period are not refundable or creditable. After the 4‑week notice period ends, your billing stops and your reserved time is released to another family."
    }
]